import { useEffect, useMemo, useState } from 'react';
import { shutdownCompaniesQuery } from '../../../api/queries';
import { getProcessedData } from '../helpers/getProcessedData';

const { useShutdownCompanies } = shutdownCompaniesQuery;

export const useAddressesTreeData = ({
  initCompaniesMap,
  cityId,
  enabled = true,
  companyId,
}) => {
  const [treeData, setTreeData] = useState([]);

  const { data: companies, isFetching } = useShutdownCompanies(cityId, {
    staleTime: Infinity,
    enabled,
  });

  const company = useMemo(() => {
    if (!enabled) return [];

    return companies?.filter((item) => item.id === companyId) || [];
  }, [companies, companyId, enabled]);


  useEffect(() => {
    let newData = [];

    if (company?.length) {
      const processedData = getProcessedData(company, initCompaniesMap);

      newData = processedData.map((company) => ({
        key: `${company.id}`,
        id: company.id,
        parentId: null,
        title: company.name,
        searchPlaceholder: 'Поиск по компании',
        isLeaf: initCompaniesMap?.size
          ? !initCompaniesMap.get(company.id)?.size
          : false,
      }));
    }

    setTreeData(newData);
  }, [company, initCompaniesMap]);

  return { treeData, setTreeData, loading: isFetching, rawData: company };
};
